
import * as React from 'react';
import {useEffect, useState} from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from 'react-redux';
import {
  Divider,
  IconButton,
  Select,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Grid,
  FormHelperText
} from '@mui/material';
import { printVariable } from '@util/helper';
import WebService from '@util/webService';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from '@hooks/useIndicator';
import axios from 'axios';
import { Fragment } from 'react';
import moment from 'moment';
import useDelegate from "@hooks/useDelegate";
import {styled} from "@mui/material/styles";
import useAlert from "@hooks/useAlert";
import ConfirmDialog from "@components/ConfirmDialog";
import { useExpanded } from 'react-table';
import Linker from '@components/Linker'

const ManagerMessagePartView = ({record, dialogHandler}) => {
  const [content, set_content] = useState('')
  const { alert, renderAlert } = useAlert()
  const schola = useSelector((state) => state.scholaReducer)
  const fetchContent = async() => {
    const url = `/topic/content/${record.section}/${schola.id}`
    const resp = await WebService.get(url)
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const content = repMessage.content
    console.log('content=>', content)
    set_content(content)
  }

  useEffect(() => {
    if(record.section) {
      fetchContent()
    }
    else {
      set_content(record.content)
    }
  }, [])

  return (
    <div style={{whiteSpace:'pre-line'}}>
      {renderAlert()}
      {/* <Linkify>{content}</Linkify> */}
      <Linker>{content}</Linker>
      {/* {content} */}
      <div style={{marginTop:10}}></div>
      {
        record.attchList && record.attchList.map((item, index) =>(
          item.fileType.includes('image') ? (
            <div key={index} style={{padding:10}}>
              <img src={`/scm/repo/${item.fileLoc}`} style={{width:'100%'}}/>
            </div>
          ) : null
        ))
      }
      <Divider />
      <div style={{display:'flex', justifyContent:'center', marginTop:20}}>
        <Button onClick={() => dialogHandler[1](false)} >
          닫기 
        </Button>
      </div>
    </div>
  )
}

export default ManagerMessagePartView
